import http from "./http";

const getCategoryCar = (params, cancelToken) => {
  return http.get("/vehicles/all-vehicles-category-paginated", {
    params,
    cancelToken,
  });
};

const createCategoryCar = (data) => {
    return http.post("/vehicles/vehicle-category", data);
};

const updateCategoryCar = (data) => {
    return http.put("/vehicles/vehicle-category", data);
};

const removeCategoryCar = (id) => {
    return http.delete("/vehicles/vehicle-category", { 
      params: { id }
    });
  };

export default {
  getCategoryCar,
  createCategoryCar,
  updateCategoryCar,
  removeCategoryCar
};
